<template>
	<div>
		<v-layout wrap>
			<v-flex xs12 mt-4 pb-5>
				<app-button
					class="new-poll"
					text="Nuevo"
					@click="goTo('new-organizational-diagnosis')"
				/>
				<surveys-list :tool-code="toolCode" />
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import surveysList from '@/components/surveys/surveys-list';
import toolsCodes from '@/shared/tools-codes';
import appButton from '@/components/shared/app-button';

const { OrgaDiagnosis } = toolsCodes;

function data() {
	return {
		toolCode: OrgaDiagnosis,
	};
}

export default {
	name: 'surveys',
	components: {
		appButton,
		surveysList,
	},
	data,
};
</script>
<style lang="scss" scoped>
.new-poll {
	border-radius: 6px;
	color: white;
	padding: 7px 17px;
}
</style>


// WEBPACK FOOTER //
// src/pages/organizational/page-surveys.vue